import { SearchInDialogQuery } from 'types/chatsType';

export type SearchDialogUrlParams = SearchInDialogQuery & {
  lastMessageId?: number;
  isAppend?: boolean;
};

export function getSearchDialogUrl(baseUrl: string, params: SearchDialogUrlParams): string {
  const { id, searchField, sd, ed, limit, lastMessageId } = params;
  const queryParams = new URLSearchParams({ searchField });

  if (sd) {
    queryParams.set('sd', sd);
  }
  if (ed) {
    queryParams.set('ed', ed);
  }
  if (limit != null) {
    queryParams.set('limit', String(limit));
  }
  if (lastMessageId != null) {
    queryParams.set('lastMessageId', String(lastMessageId));
  }

  return `${baseUrl}/search-messages/${id}?${queryParams}`;
}

export function toSearchInDialogQuery(params: SearchDialogUrlParams): SearchInDialogQuery {
  const { isAppend, lastMessageId, ...query } = params;
  return query;
}
